(function(){
  //公告栏---关闭
  var diagramCK="None";
  $("body").on('click','#notice #notic_close',function(){
    $("#notice").addClass("hideBoard");
    diagramCK="Block";
  });
  //滚动滚动条
    $(document).scroll(function() {
      var scroH = $(document).scrollTop();  //滚动高度
          if(scroH>0){
            if(diagramCK == "None"){
        		$("#notice").addClass('hideBoard');
            }
            $("body").addClass('pdDistance');
          }else{
            if(diagramCK == "None"){
               $("#notice").removeClass('hideBoard');
            }
            $("body").removeClass('pdDistance');
          }
      });
//显示公告栏之后判断下方
  
  //点击菜单栏三横杠的时候，把菜单栏变为
  $(".menu-toggle").click(function(){
  	$(".pdDistance").addClass("mous");
  })
})();